
export const breadcrumbMap = {
    support: "Support",  
    ":id": (params) => params.id,
  };
  